import { ref } from 'vue';

const useQueue = () => {
  const queue = ref([]);
  const isWorking = ref(false);

  const processQueue = async () => {
    if (isWorking.value || queue.value.length <= 0) {
      return;
    }

    isWorking.value = true;
    await queue.value[0]();
    queue.value.splice(0, 1);
    isWorking.value = false;

    await processQueue();
  };

  const addToQueue = async fn => {
    queue.value.push(fn);
    await processQueue();
  };

  return {
    queue,
    isWorking,
    processQueue,
    addToQueue,
  };
};

export default useQueue;
